var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.title)?_c('nuxt-link',{attrs:{"to":("/product-catalog/rating/charts/" + _vm.id)}},[_c('base-field',{attrs:{"title":_vm.title,"icon":"chevron-circle"}})],1):_c('span',[_vm._v(" — ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }